import React, { useEffect, useState } from "react";
import { Table, Typography } from "antd";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkAgent ,stoageSetter,stoageGetter} from "../../helpers";
import * as actions from "../../store/actions/leads";

const { Link, Text } = Typography;

const TeamPerformanceTable = ({ data, showManagerColumn = true, onTeamMemberClick }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState([]);

  const userTreeData = useSelector((state) => state?.home?.user_tree);
  const selectedFilter = useSelector(state => state.leads.selectedFilterByVal);
  // console.log("userTreeData---PERFORMANCETABLE------?>>>>>", userTreeData);

  useEffect(() => {
  
    generateTableData(userTreeData);
  }, [selectedFilter]);

    const generateTableData = (userTreeData) => {
        const tableData = [];
        const grandTotal = {
            isGrandTotal: true,
            name: "Grand Total",
            all: 0,
            wip: 0,
            pendingProcessing: 0,
            completed: 0,
            rts: 0,
            total: 0,
            manager: "",
        };
        const count_key =
            selectedFilter === 'mtd'
              ? 'proposalCount_mtd'
              : selectedFilter === 't60'
              ? 'proposalCount_t60'
              : 'proposalCount';

        userTreeData?.reporting_managers?.forEach((manager) => {
            const managerName = `${manager.first_name} ${manager.last_name}`;
            const users = userTreeData.reporting_users?.filter(
            (user) => user.reporting_manager === manager._id
            );

            let selfUser = manager
            // Find the manager's own user object
            // if(userTreeData?.reporting_managers.length > 1){
            //   selfUser = userTreeData.reporting_users?.find(
            //     (user) => user._id === manager._id
            //   );
            // }else{
            //   selfUser = userTreeData.reporting_users?.find(
            //     (user) => user.reporting_manager === manager._id
            //   );
            // }

            const managerTotal = {
                isManagerTotal: true,
                manager: showManagerColumn ? managerName : "",
                name: `${managerName} Total`,
                all: 0,
                wip: 0,
                pendingProcessing: 0,
                completed: 0,
                rts: 0,
                total: 0,
            };

            // Add manager as first entry if found
            if (selfUser) {
                const managerData = {
                    isManagerTotal: false,
                    isGrandTotal: false,
                    isManager: showManagerColumn,
                    manager: managerName,
                    name: `${managerName} (Self)`,
                    all: selfUser?.[count_key]?.all || 0,
                    wip: selfUser?.[count_key]?.wip || 0,
                    pendingProcessing: selfUser?.[count_key]?.pendingProcessing || 0,
                    completed: selfUser?.[count_key]?.completed || 0,
                    rts: selfUser?.[count_key]?.rts || 0,
                    total: selfUser?.[count_key]?.total || 0,
                    allData: selfUser,
                };
                // Aggregate for manager
                managerTotal.all += managerData.all;
                managerTotal.wip += managerData.wip;
                managerTotal.pendingProcessing += managerData.pendingProcessing;
                managerTotal.completed += managerData.completed;
                managerTotal.rts += managerData.rts;
                managerTotal.total += managerData.total;

                tableData.push(managerData);
            }

            users?.forEach((user) => {
                // Skip the manager's own entry if already added above
                if (selfUser && user._id === selfUser._id) return;
                const userData = {
                    isManagerTotal: false,
                    isGrandTotal: false,
                    isManager: showManagerColumn,
                    manager: "",
                    name: user.full_name,
                    all: user?.[count_key]?.all || 0,
                    wip: user?.[count_key]?.wip || 0,
                    pendingProcessing: user?.[count_key]?.pendingProcessing || 0,
                    completed: user?.[count_key]?.completed || 0,
                    rts: user?.[count_key]?.rts || 0,
                    total: user?.[count_key]?.total || 0,
                    allData: user,
                };
                // Aggregate for manager
                managerTotal.all += userData.all;
                managerTotal.wip += userData.wip;
                managerTotal.pendingProcessing += userData.pendingProcessing;
                managerTotal.completed += userData.completed;
                managerTotal.rts += userData.rts;
                managerTotal.total += userData.total;

                tableData.push(userData);
            });

            // Add manager total row
            tableData.push(managerTotal);

            // Add to grand total
            grandTotal.all += managerTotal.all;
            grandTotal.wip += managerTotal.wip;
            grandTotal.pendingProcessing += managerTotal.pendingProcessing;
            grandTotal.completed += managerTotal.completed;
            grandTotal.rts += managerTotal.rts;
            grandTotal.total += managerTotal.total;
        });

        // Push grand total row at the end
        grandTotal.manager = showManagerColumn ? "Grand Total" : "";
        tableData.push(grandTotal);
        setTableData(tableData);
    }

    // 🔧 Helper to simulate values
    const getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
    }


  const handleNameClick = (event) => {
    console.log("name----------", event.allData);
    dispatch(actions.proposalTeamData(event.allData));
    dispatch(actions.proposalTeamSelect(false));
    dispatch(actions.showProposalTable(true));
    if (onTeamMemberClick && typeof onTeamMemberClick === 'function') {
      onTeamMemberClick(event.allData);
    }
    // history.push(`/proposals?user=${encodeURIComponent(name)}`);
  };

  const baseColumns = [
    {
      title: "Team Member",
      dataIndex: "name",
      key: "name",
      onHeaderCell: () => ({
        style: { textAlign: "left" },
      }),
      width: 200,
      render: (text, record) => {
        if (record.isManagerTotal || record.isGrandTotal) {
          return record.isGrandTotal ? "" : <Text strong>{text}</Text>;
        } else {
          return <Text onClick={() => handleNameClick(record)} style={{ textDecoration: 'underline', color: 'inherit', cursor: 'pointer' }}
          >{text}</Text>;
        }
      },
    },
    // {
    //   title: "All",
    //   dataIndex: "all",
    //   key: "all",
    //   width: 180,
    //   align: "left",
    //   render: (value, record) => (
    //     <Text strong={record.isGrandTotal}>{value}</Text>
        
    //   ),
    // },


    // {
    //   title: "All",
    //   dataIndex: "all",
    //   key: "all",
    //   width: 70,
    //   onHeaderCell: () => ({
    //     style: { textAlign: "left" },
    //   }),
    //   onCell: () => ({
    //     style: { textAlign: "right" },
    //   }),
    //   render: (value, record) => (
    //     <Text strong={record.isGrandTotal}>{value}</Text>
    //   ),
    // },
    
    {
      title: "WIP",
      dataIndex: "wip",
      key: "wip",
      width: 70,
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
      onCell: () => ({
        style: { textAlign: "right" },
      }),
      render: (value, record) => (
        <Text strong={record.isGrandTotal}>{value}</Text>
      ),
    },
    {
      title: "Pending For Processing",
      dataIndex: "pendingProcessing",
      key: "pendingProcessing",
      width: 110,
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
      onCell: () => ({
        style: { textAlign: "right" },
      }),
      render: (value, record) => (
        <Text strong={record.isGrandTotal}>{value}</Text>
      ),
    },
    {
      title: "RTS",
      dataIndex: "rts",
      key: "rts",
      width: 70,
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
      onCell: () => ({
        style: { textAlign: "right" },
      }),
      render: (value, record) => (
        <Text strong={record.isGrandTotal}>{value}</Text>
      ),
    },
    {
      title: "Issued",
      dataIndex: "completed",
      key: "completed",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
      onCell: () => ({
        style: { textAlign: "right" },
      }),
      width:80,
      render: (value, record) => (
        <Text strong={record.isGrandTotal}>{value}</Text>
      ),
    },
  ];

  const managerColumn = {
    title: "Manager",
    dataIndex: "manager",
    key: "manager",
    onHeaderCell: () => ({
      style: { textAlign: "left" },
    }),
    width:130,
      // render: (_, record) =>
      //   record.isManager ? (
      //     <Text strong>{record.manager}</Text>
      //   ) : record.isManagerTotal || record.isGrandTotal ? (
      //     ""
      //   ) : (
      //     ""
      //   ),
      render: (_, record) => {
        // console.log('Manager_DATA---------------',record)
        if (record.isManager || record.isGrandTotal) {
          return <Text strong>{record.manager}</Text>;
        }
        return "";
      },
  };

  const columns = showManagerColumn
    ? [managerColumn, ...baseColumns]
    : baseColumns;
    // console.log("(((((((((((tableData)))))))))))", tableData);

  return (
    <div style={{ overflowX: 'auto',marginTop:10 }}>
      <Table
        columns={columns}
        dataSource={tableData}
        bordered
        size="small"
        pagination={false}
        rowKey={(record, index) => `${record.name}-${index}`}
        scroll={{ x: 'max-content' }}
        rowClassName={(record) => {
          if (record.isManagerTotal) return "manager-total-row";
          if (record.isGrandTotal) return "grand-total-row";
          return "";
        }}
      
        components={{
          header: {
            cell: (props) => (
              <th style={{ 
                ...props.style, 
                backgroundColor: "#1a60bc", 
                color: "white", 
                fontWeight: "bold",
                flex: 1,
                padding:"8px 12px",
                height: '40px',
                position: showManagerColumn && props.children === "Manager" ? 'sticky' : 'relative',
                left: showManagerColumn && props.children === "Manager" ? 0 : 'auto',
                zIndex: showManagerColumn && props.children === "Manager" ? 2 : 1
              }}>
                {props.children}
              </th>
            ),
          },
          body: {
            row: (props) => {
              const { className, ...restProps } = props;
              let bgColor = "#fff";
              if (className?.includes("manager-total-row")) bgColor = "#D3D3D3";
              if (className?.includes("grand-total-row")) bgColor = "#FFD900";
      
              return (
                <tr
                  {...restProps}
                  style={{
                    backgroundColor: bgColor,
                    fontWeight: className?.includes("manager-total-row")
                      ? "bold"
                      : className?.includes("grand-total-row")
                      ? "bold"
                      : "normal",
                  }}
                />
              );
            },
            cell: (props) => {
              const isManagerColumn = showManagerColumn && props.children?.props?.children === "Manager";
              const isTeamMemberColumn = props.children?.props?.children?.includes("Team Member");
              
              return (
                <td style={{
                  ...props.style,
                  padding:"8px 12px",
                  height: '40px',
                  fontSize: '14px',
                  position: (isManagerColumn || isTeamMemberColumn) ? 'sticky' : 'relative',
                  left: isManagerColumn ? 0 : isTeamMemberColumn ? (showManagerColumn ? 130 : 0) : 'auto',
                  backgroundColor: (isManagerColumn || isTeamMemberColumn) ? '#fff' : 'transparent',
                  zIndex: (isManagerColumn || isTeamMemberColumn) ? 1 : 0
                }}>
                  {props.children}
                </td>
              );
            }
          }
        }}
      />
    </div>
  );
};

export default TeamPerformanceTable;
